import { useCallback } from 'react';
import { appendParams, finalizeUrl, getDefaultDeeplink } from '../../utils';
import { useOpenDeeplink } from '../../../../hooks';

/**
 * - 찜 서랍 페이지로 이동
 */
export const useMoveToLikeFolders = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(
    ({ folderSno }: { folderSno: number }) => {
      const url = getDefaultDeeplink();
      appendParams(url, 'screen', 'FolderDetail');
      appendParams(url, 'extras', JSON.stringify({ sno: folderSno }));
      openDeeplink(finalizeUrl(url));
    },
    [openDeeplink],
  );
};
